import { createRoot } from 'react-dom/client'

import LayoutContainer from '@/components/LayoutContainer'

import App from './App.js'

import './index.css'
import '@/assets/styles/globals.scss'

createRoot(document.getElementById('root')).render(
  <LayoutContainer>
    <App />
  </LayoutContainer>
)
